import * as React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { Form } from "semantic-ui-react";
import { FormBaseComponent, SaveDispatchProps } from "@neworbit/simpleui-forms";
import { Input } from "@neworbit/simpleui-input";

import { SraCustomerUserCreateModel, AppState, SRA_CUSTOMER_USER_ROLES } from "../model";
import { basePathSelector } from "../selectors";
import { createSraCustomerUser } from "../actions";

import { SraCustomer, selectors } from "../../sraCustomer";
import { sraDepartmentsSelector } from "../../sraDepartment/selectors";
import { ApplicationState } from "../../../applicationState";
import { SraDepartment, loadSraDepartments } from "../../sraDepartment";

import { CreateModal } from "./CreateModal";

import { push } from "redux-little-router";

export interface CreateProps {
    open: boolean;
    sraCustomer: SraCustomer;
    departments: SraDepartment[];
}

export interface DispatchProps extends SaveDispatchProps<SraCustomerUserCreateModel> {
    close: () => void;
    loadSraDepartmentOptions: () => void;
}

export class CreateUnconnected extends FormBaseComponent<SraCustomerUserCreateModel, CreateProps> {

    constructor(props: CreateProps & SaveDispatchProps<SraCustomerUserCreateModel>) {
        super(props);
        this.state = {
            values: {
                id: "0",
                firstName: "",
                lastName: "",
                departmentId: "",
                emailAddress: "",
                roles: []
            },
            valid: {}
        };
    }

    public UNSAFE_componentWillReceiveProps(props: CreateProps & SaveDispatchProps<SraCustomerUserCreateModel>) {
        this.setState(current => ({ values: { ...current.values, sraCustomerId: props.sraCustomer.id } }));
    }

    public render() {
        return (
            <Form onSubmit={this.handleSubmit}>

                <Input.Text
                    value={this.state.values.firstName}
                    label="First Name"
                    showErrors={this.state.showErrors}
                    required
                    onChange={(value, valid) => this.updateProperty("firstName", value, valid)}
                />

                <Input.Text
                    value={this.state.values.lastName}
                    label="Last Name"
                    showErrors={this.state.showErrors}
                    required
                    onChange={(value, valid) => this.updateProperty("lastName", value, valid)}
                />

                <Input.Dropdown
                    dynamicOptions
                    options={this.props.departments.map(d => ({ text: d.name, value: d.id }))}
                    value={this.state.values.departmentId}
                    label="Department"
                    showErrors={this.state.showErrors}
                    required
                    onChange={(value, valid) => this.updateProperty("departmentId", value, valid)}
                />

                <Input.Text
                    value={this.state.values.emailAddress}
                    label="Email Address"
                    showErrors={this.state.showErrors}
                    required
                    onChange={(value, valid) => this.updateProperty("emailAddress", value, valid)}
                />

                <Input.DropdownMulti
                    options={(Object.keys(SRA_CUSTOMER_USER_ROLES) as (keyof typeof SRA_CUSTOMER_USER_ROLES)[]).map(k => (
                        { text: SRA_CUSTOMER_USER_ROLES[k].displayName, value: SRA_CUSTOMER_USER_ROLES[k].name }))}
                    value={this.state.values.roles}
                    label="Roles"
                    showErrors={this.state.showErrors}
                    required
                    onChange={(value, valid) => this.updateProperty("roles", value, valid)}
                />
            </Form>
        );
    }

    public submit(): void {
        this.handleSubmit({ preventDefault: (): void => undefined } as any);
    }
}

function mapStateToProps(state: ApplicationState) {
    return {
        sraCustomerId: selectors.routeIdSelector(state),
        sraCustomer: selectors.sraCustomerSelector(state),
        open: state.router.pathname.endsWith("/create"),
        basePath: basePathSelector(state),
        departments: sraDepartmentsSelector(state)
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>) {
    return {
        dispatchSave: (sraCustomerId: string, sraCustomerUser: SraCustomerUserCreateModel, basePath: string) =>
            dispatch(createSraCustomerUser(sraCustomerId, sraCustomerUser, basePath)),
        dispatchClose: (basePath: string) => dispatch(push(basePath, {})),
        loadSraDepartmentOptions: (sraCustomerId: string) => dispatch(loadSraDepartments({ sraCustomerId }))
    };
}

function mergeProps(propsFromState: any, propsFromDispatch: any): CreateProps & DispatchProps {
    return {
        sraCustomer: propsFromState.sraCustomer,
        departments: propsFromState.departments,
        open: propsFromState.open,
        save: (sraCustomerUser: SraCustomerUserCreateModel) =>
            propsFromDispatch.dispatchSave(propsFromState.sraCustomerId, sraCustomerUser, propsFromState.basePath),
        close: () => propsFromDispatch.dispatchClose(propsFromState.basePath),
        loadSraDepartmentOptions: ()  => propsFromDispatch.loadSraDepartmentOptions(propsFromState.sraCustomerId)
    };
}

export const Create = connect(mapStateToProps, mapDispatchToProps, mergeProps)(CreateModal);
